<!--=============================
=            ECHARTS            =
==============================-->

<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Echarts</div>
      </base-header>
    </v-row>
    <v-row>
      <template>
       
       <v-col cols="12" md="6" sm="12">
          <base-card>
            <div slot="card-header">

            Pie
            </div><div slot="card-subheader">Pie eCharts</div>
            <div slot="card-body">
           <echarts-pie></echarts-pie>
            </div>
          </base-card>
        </v-col>
        <v-col cols="12" md="6" sm="12">
          <base-card>
            <div slot="card-header">

             Collun
            </div><div slot="card-subheader">Collumn eCharts</div>
            <div slot="card-body">
              <echarts-column></echarts-column>
            </div>
          </base-card>
        </v-col>
         <v-col cols="12" md="6" sm="12">
          <base-card>
            <div slot="card-header">

             Bar Line
            </div><div slot="card-subheader">Multiple Charts Bar Line eCharts</div>
            <div slot="card-body">
              <echarts-bar-line></echarts-bar-line>
            </div>
          </base-card>
        </v-col> <v-col cols="12" md="6" sm="12">
          <base-card>
            <div slot="card-header">
Echart Area
            </div><div slot="card-subheader">Multiple Charts Area eCharts</div>
            <div slot="card-body">
          <echarts-area></echarts-area>
            </div>
          </base-card>
        </v-col>

      </template>
    </v-row>
  

  </div>

</template>
<script>
import BaseCard from "../../components/Base/BaseCard.vue";
import BaseHeader from "../../components/Base/BaseHeader.vue";
import EchartsArea from '../../components/Charts/EchartsArea'

import EchartsBarLine from '../../components/Charts/EchartsBarLine'
import EchartsColumn from '../../components/Charts/EchartsColumn'

import EchartsPie from '../../components/Charts/EchartsPie'
import EchartsPolarBar from '../../components/Charts/EchartsPolarBar'
export default {
  components: {
    BaseCard,
    BaseHeader,
    EchartsArea,EchartsBarLine,EchartsColumn,EchartsPie,EchartsPolarBar
  },
 
};
</script>

<!--====  End of ECHARTS  ====-->
